"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.b64ToBlob = exports.addIdentifierToArray = void 0;
exports.capitalize = capitalize;
exports.capitalizeFirst = capitalizeFirst;
exports.capitalizeWords = capitalizeWords;
exports.checkEmailExists = checkEmailExists;
exports.checkEmailExistsInStructure = checkEmailExistsInStructure;
exports.convertBlobToBase64 = void 0;
exports.convertToLocaleDate = convertToLocaleDate;
exports.convertToLocaleDateDDMMYYHHmmss = convertToLocaleDateDDMMYYHHmmss;
exports.convertToLocaleDateMMddYY = convertToLocaleDateMMddYY;
exports.convertToLocaleDateMMddYYHH = convertToLocaleDateMMddYYHH;
exports.convertToLocaleDateYYYYMMDD = convertToLocaleDateYYYYMMDD;
exports.convertToLocaleDateddMMYY = convertToLocaleDateddMMYY;
exports.convertToLocaleDateddMMYYHH = convertToLocaleDateddMMYYHH;
exports.debounce = debounce;
exports.formatAmount = exports.flattenObject = void 0;
exports.getBase64FileHeader = getBase64FileHeader;
exports.getDMYhmDate = getDMYhmDate;
exports.getDMhmDate = getDMhmDate;
exports.getISO2FromISO3CountryCode = exports.getFullTableDate = exports.getFileExtensionFromB64 = void 0;
exports.getRandomArbitrary = getRandomArbitrary;
exports.getRandomInt = getRandomInt;
exports.getTime = exports.getTablePeriod = exports.getTableDate = void 0;
exports.getUtcDate = getUtcDate;
exports.hexToRgba = void 0;
exports.isEmpty = isEmpty;
exports.isEmptyString = isEmptyString;
exports.isJSONString = isJSONString;
exports.isNullOrUndefined = void 0;
exports.isObject = isObject;
exports.mergeDeep = mergeDeep;
exports.objectFiltering = void 0;
exports.parseData = parseData;
exports.parseDocumentProps = parseDocumentProps;
exports.parseSettings = parseSettings;
exports.quantityParser = quantityParser;
exports.randomId = randomId;
exports.removeStringB64 = void 0;
exports.switchValueByType = switchValueByType;
exports.titleCase = titleCase;
exports.transformDateToString = void 0;
exports.validateEmail = validateEmail;
exports.validateRiskCountry = validateRiskCountry;

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _union = _interopRequireDefault(require("lodash/union"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _utc = _interopRequireDefault(require("dayjs/plugin/utc"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

_dayjs.default.extend(_utc.default);

function getDMYhmDate(date) {
  return date.substr(0, 10) + ' ' + date.substr(11, 5);
}

function getUtcDate(date) {
  return _dayjs.default.utc(date).local().format('DD/MM/YYYY HH:mm');
}
/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */


function isObject(item) {
  return item && _typeof(item) === 'object' && !Array.isArray(item);
}

var getTableDate = function getTableDate(date) {
  return date ? date.substr(8, 2) + '/' + date.substr(5, 2) + '/' + date.substr(0, 4) : '';
};
/**
 * @return {string}
 */


exports.getTableDate = getTableDate;

var transformDateToString = function transformDateToString(date) {
  var dateAdding12h = (0, _dayjs.default)(date).add(12, 'hour');
  var stringDate = JSON.stringify(dateAdding12h);
  return JSON.parse(stringDate);
};
/**
 * @return {string}
 */


exports.transformDateToString = transformDateToString;

var getTablePeriod = function getTablePeriod(date) {
  return date ? date.substr(5, 10) + ' ' + date.substr(21, 10) : '';
};
/**
 * @return {string}
 */


exports.getTablePeriod = getTablePeriod;

var getTime = function getTime(date) {
  return date ? date.substr(11, 5) : '';
};
/**
 * @return {string}
 */


exports.getTime = getTime;

var getFullTableDate = function getFullTableDate(date) {
  return date ? date.substr(8, 2) + '/' + date.substr(5, 2) + '/' + date.substr(0, 4) + ' ' + date.substr(11, 5) : '';
};
/**
 * @return {string}
 */


exports.getFullTableDate = getFullTableDate;

function convertToLocaleDate(date) {
  return _dayjs.default.utc(date).toDate().toLocaleString();
}
/**
 * @return {string}
 */


function convertToLocaleDateddMMYY(date) {
  return _dayjs.default.utc(date).format('DD/MM/YYYY');
}
/**
 * @return {string}
 */


function convertToLocaleDateMMddYY(date) {
  return _dayjs.default.utc(date).format('MM/DD/YYYY');
}
/**
 * @return {string}
 */


function convertToLocaleDateYYYYMMDD(date) {
  var convert = new Date(date);
  return _dayjs.default.utc(convert).format('YYYY-MM-DD');
}
/**
 * @return {string}
 */


function convertToLocaleDateddMMYYHH(date) {
  return _dayjs.default.utc(date).format('DD/MM/YYYY HH:mm');
}
/**
 * @return {string}
 */


function convertToLocaleDateMMddYYHH(date) {
  return _dayjs.default.utc(date).format('MM/DD/YYYY HH:mm');
}
/**
 * @return {string}
 */


function convertToLocaleDateDDMMYYHHmmss(date) {
  return _dayjs.default.utc(date).local().format('DD/MM/YYYY HH:mm:ss');
}
/**
 * @return {string}
 */


function getDMhmDate(date) {
  return date.substr(5, 5) + ' ' + date.substr(11, 5);
}
/**
 * @return {string}
 */


function capitalizeFirst(string) {
  return string.charAt(0).toUpperCase() + string.substr(1);
}
/**
 * @return {string}
 */


function capitalizeWords(text) {
  if (typeof text !== 'string') return text;
  text = text.toLowerCase().split(' ').map(function (s) {
    return s.charAt(0).toUpperCase() + s.substring(1);
  }).join(' ');
  return text;
}
/**

/**
 * @return {string}
 */


function capitalize(str) {
  if (!str) return '';
  str = str.split(" ");

  for (var i = 0, x = str.length; i < x; i++) {
    str[i] = str[i][0].toUpperCase() + str[i].substr(1);
  }

  return str.join(" ");
}
/**
* @return {boolean}
*/


function validateEmail(inputText) {
  var mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return inputText.match(mailformat) != null;
}
/**
* @return {boolean}
*/


function validateRiskCountry(country, countryList) {
  return countryList ? !!countryList.find(function (c) {
    return c.code === country;
  }) : false;
}

function validateRiskCountries(countries, countryList) {
  var array = countryList ? countryList.map(function (op) {
    return op.code;
  }) : [];
  return countryList ? countries.every(function (c) {
    return array.includes(c);
  }) : false;
}
/**
* @return {boolean}
*/


function checkEmailExists(_x) {
  return _checkEmailExists.apply(this, arguments);
}
/**
* @return {boolean}
*/


function _checkEmailExists() {
  _checkEmailExists = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(email) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _checkEmailExists.apply(this, arguments);
}

function checkEmailExistsInStructure(_x2, _x3) {
  return _checkEmailExistsInStructure.apply(this, arguments);
}
/**
* @return uniqueId
*/


function _checkEmailExistsInStructure() {
  _checkEmailExistsInStructure = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(email, id) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _checkEmailExistsInStructure.apply(this, arguments);
}

function randomId() {
  return '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
}
/**
* @return {boolean}
*/


function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }

  return true;
}
/**
* @return {boolean}
*/


function isEmptyString(str) {
  if (typeof str == 'undefined' || !str || str.length === 0 || str === "" || !/[^\s]/.test(str) || /^\s*$/.test(str) || str.replace(/\s/g, "") === "") {
    return true;
  } else {
    return false;
  }
}
/**
* @return {boolean}
*/


function isJSONString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
}
/**
 * @return {Number}
 */


function quantityParser(quantity) {
  if (Number(quantity) || quantity === 0) return quantity;
  quantity = quantity.split(',').join('.');

  var _quantity = quantity.split(' ').join('');

  var last = _quantity.substr(_quantity.length - 1).toLowerCase();

  var first = _quantity.substr(0, _quantity.length - 1);

  if (last === 'k') last = 1000;
  if (last === 'm') last = 1000000;
  if (Number(last) && Number(first)) quantity = first * last;
  return quantity;
}
/**
 * Returns a random number between min (inclusive) and max (exclusive)
 */


function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}
/**
 * Returns a random integer between min (inclusive) and max (inclusive)
 * Using Math.round() will give you a non-uniform distribution!
 */


function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * @return String
 *
 * -Returns the file extension
 */


function getBase64FileHeader(firstCharacter) {
  switch (firstCharacter) {
    case '/':
      return 'data:image/jpeg;base64,';

    case 'i':
      return 'data:image/png;base64,';

    case 'J':
      return 'data:application/pdf;base64,';

    case 'A':
      return 'data:video/mp4;base64,';

    case 'U':
      return 'data:image/webp;base64,';

    case 'G':
      return 'data:video/webm;base64,';

    default:
      console.error('unknown data type');
  }
}
/**
 * @return Blob
 *
 * -Returns the file extension
 */


var b64ToBlob = function b64ToBlob(b64Data) {
  var sliceSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;

  var getFileType = function getFileType(firstCharacter) {
    switch (firstCharacter) {
      case '/':
        return 'image/jpg';

      case 'i':
        return 'image/png';

      case 'J':
        return 'application/pdf';

      case 'A':
        return 'video/mp4';

      case 'U':
        return 'image/webp';

      case 'G':
        return 'video/webm';

      default:
        console.error('unknown data type');
    }
  };

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);

    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {
    type: getFileType(b64Data.charAt(0))
  });
};
/**
 * @return String
 *
 * -Returns the file extension
 */


exports.b64ToBlob = b64ToBlob;

var getFileExtensionFromB64 = function getFileExtensionFromB64(firstCharacter) {
  switch (firstCharacter) {
    case '/':
      return '.jpg';

    case 'i':
      return '.png';

    case 'J':
      return '.pdf';

    case 'A':
      return '.mp4';

    case 'U':
      return '.webp';

    case 'G':
      return '.webm';

    default:
      console.error('unknown extension');
  }
};
/**
  * Checks if the given value is null or undefined
  * @param val
  * @returns {boolean}
  */


exports.getFileExtensionFromB64 = getFileExtensionFromB64;

var isNullOrUndefined = function isNullOrUndefined(val) {
  return val === null || val === undefined;
};
/**
 * Flatten a given object on one depth level
 * @param obj
 * @returns {{}}
 */


exports.isNullOrUndefined = isNullOrUndefined;

var flattenObject = function flattenObject() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(obj).reduce(function (a, b) {
    if (isObject(obj[b])) a = _objectSpread(_objectSpread({}, a), obj[b]);else a[b] = obj[b];
    return a;
  }, {});
};
/**
 * Adds an identifier to an array of objects
 * @param array
 * @returns {[]}
 */


exports.flattenObject = flattenObject;

var addIdentifierToArray = function addIdentifierToArray(array) {
  return array && array.map(function (element, index) {
    return _objectSpread(_objectSpread({}, element), {}, {
      identifier: index
    });
  });
};
/**
 * Filter an object as an array
 * @param object, filterBy
 * @returns {}
 */


exports.addIdentifierToArray = addIdentifierToArray;

var objectFiltering = function objectFiltering(object, filterBy) {
  var filteredObject = Object.keys(object).filter(function (key) {
    return filterBy.includes(key);
  }).reduce(function (obj, key) {
    obj[key] = object[key];
    return obj;
  }, {});
  return filteredObject;
};
/** Returns a function, that, as long as it continues to be invoked, will not
* be triggered. The function will be called after it stops being called for
* N milliseconds. If `immediate` is passed, trigger the function on the
* leading edge, instead of the trailing.
* var myEfficientFn = debounce(function() {All the taxing stuff you do}, 250);
*/


exports.objectFiltering = objectFiltering;

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
/*
 * Returns the rgb of hex value
 * @param hex
 * @param alpha
 * @returns {*}
 */


var hexToRgba = function hexToRgba(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? "rgba(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ", ").concat(alpha, ")") : null;
};
/**
 * Format amount
 * @param value
 * @param fixedDecimals
 * @param formatInteger
 * @param decimalSeparator
 * @returns {string}
 */


exports.hexToRgba = hexToRgba;

var formatAmount = function formatAmount() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var fixedDecimals = arguments.length > 1 ? arguments[1] : undefined;
  var formatInteger = arguments.length > 2 ? arguments[2] : undefined;
  var decimalSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  var result = value % 1 === 0 ? value : value.toFixed(fixedDecimals);
  var parts = result.toString().includes(".") ? result.toString().split('.') : result.toString().split(',');
  var integer = formatInteger ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, decimalSeparator === '.' ? ',' : '.') : parts[0];
  var decimals = parts.length > 1 ? parts[1] : null;
  return decimals ? [integer, decimals].join(decimalSeparator) : integer;
};
/**
 * Transform ISO3 country code into ISO2 code
 * @param countryISO3Code
 * @returns {*}
 */


exports.formatAmount = formatAmount;

var getISO2FromISO3CountryCode = function getISO2FromISO3CountryCode(countryISO3Code) {
  var iso2toIso3 = {
    AFG: 'AF',
    ALB: 'AL',
    DZA: 'DZ',
    ASM: 'AS',
    AND: 'AD',
    AGO: 'AO',
    AIA: 'AI',
    ATA: 'AQ',
    ATG: 'AG',
    ARG: 'AR',
    ARM: 'AM',
    ABW: 'AW',
    AUS: 'AU',
    AUT: 'AT',
    AZE: 'AZ',
    BHS: 'BS',
    BHR: 'BH',
    BGD: 'BD',
    BRB: 'BB',
    BLR: 'BY',
    BEL: 'BE',
    BLZ: 'BZ',
    BEN: 'BJ',
    BMU: 'BM',
    BTN: 'BT',
    BOL: 'BO',
    BES: 'BQ',
    BIH: 'BA',
    BWA: 'BW',
    BVT: 'BV',
    BRA: 'BR',
    IOT: 'IO',
    BRN: 'BN',
    BGR: 'BG',
    BFA: 'BF',
    BDI: 'BI',
    CPV: 'CV',
    KHM: 'KH',
    CMR: 'CM',
    CAN: 'CA',
    CYM: 'KY',
    CAF: 'CF',
    TCD: 'TD',
    CHL: 'CL',
    CHN: 'CN',
    CXR: 'CX',
    CCK: 'CC',
    COL: 'CO',
    COM: 'KM',
    COD: 'CD',
    COG: 'CG',
    COK: 'CK',
    CRI: 'CR',
    HRV: 'HR',
    CUB: 'CU',
    CUW: 'CW',
    CYP: 'CY',
    CZE: 'CZ',
    CIV: 'CI',
    DNK: 'DK',
    DJI: 'DJ',
    DMA: 'DM',
    DOM: 'DO',
    ECU: 'EC',
    EGY: 'EG',
    SLV: 'SV',
    GNQ: 'GQ',
    ERI: 'ER',
    EST: 'EE',
    SWZ: 'SZ',
    ETH: 'ET',
    FLK: 'FK',
    FRO: 'FO',
    FJI: 'FJ',
    FIN: 'FI',
    FRA: 'FR',
    GUF: 'GF',
    PYF: 'PF',
    ATF: 'TF',
    GAB: 'GA',
    GMB: 'GM',
    GEO: 'GE',
    DEU: 'DE',
    GHA: 'GH',
    GIB: 'GI',
    GRC: 'GR',
    GRL: 'GL',
    GRD: 'GD',
    GLP: 'GP',
    GUM: 'GU',
    GTM: 'GT',
    GGY: 'GG',
    GIN: 'GN',
    GNB: 'GW',
    GUY: 'GY',
    HTI: 'HT',
    HMD: 'HM',
    VAT: 'VA',
    HND: 'HN',
    HKG: 'HK',
    HUN: 'HU',
    ISL: 'IS',
    IND: 'IN',
    IDN: 'ID',
    IRN: 'IR',
    IRQ: 'IQ',
    IRL: 'IE',
    IMN: 'IM',
    ISR: 'IL',
    ITA: 'IT',
    JAM: 'JM',
    JPN: 'JP',
    JEY: 'JE',
    JOR: 'JO',
    KAZ: 'KZ',
    KEN: 'KE',
    KIR: 'KI',
    PRK: 'KP',
    KOR: 'KR',
    KWT: 'KW',
    KGZ: 'KG',
    LAO: 'LA',
    LVA: 'LV',
    LBN: 'LB',
    LSO: 'LS',
    LBR: 'LR',
    LBY: 'LY',
    LIE: 'LI',
    LTU: 'LT',
    LUX: 'LU',
    MAC: 'MO',
    MDG: 'MG',
    MWI: 'MW',
    MYS: 'MY',
    MDV: 'MV',
    MLI: 'ML',
    MLT: 'MT',
    MHL: 'MH',
    MTQ: 'MQ',
    MRT: 'MR',
    MUS: 'MU',
    MYT: 'YT',
    MEX: 'MX',
    FSM: 'FM',
    MDA: 'MD',
    MCO: 'MC',
    MNG: 'MN',
    MNE: 'ME',
    MSR: 'MS',
    MAR: 'MA',
    MOZ: 'MZ',
    MMR: 'MM',
    NAM: 'NA',
    NRU: 'NR',
    NPL: 'NP',
    NLD: 'NL',
    NCL: 'NC',
    NZL: 'NZ',
    NIC: 'NI',
    NER: 'NE',
    NGA: 'NG',
    NIU: 'NU',
    NFK: 'NF',
    MNP: 'MP',
    NOR: 'NO',
    OMN: 'OM',
    PAK: 'PK',
    PLW: 'PW',
    PSE: 'PS',
    PAN: 'PA',
    PNG: 'PG',
    PRY: 'PY',
    PER: 'PE',
    PHL: 'PH',
    PCN: 'PN',
    POL: 'PL',
    PRT: 'PT',
    PRI: 'PR',
    QAT: 'QA',
    MKD: 'MK',
    ROU: 'RO',
    RUS: 'RU',
    RWA: 'RW',
    REU: 'RE',
    BLM: 'BL',
    SHN: 'SH',
    KNA: 'KN',
    LCA: 'LC',
    MAF: 'MF',
    SPM: 'PM',
    VCT: 'VC',
    WSM: 'WS',
    SMR: 'SM',
    STP: 'ST',
    SAU: 'SA',
    SEN: 'SN',
    SRB: 'RS',
    SYC: 'SC',
    SLE: 'SL',
    SGP: 'SG',
    SXM: 'SX',
    SVK: 'SK',
    SVN: 'SI',
    SLB: 'SB',
    SOM: 'SO',
    ZAF: 'ZA',
    SGS: 'GS',
    SSD: 'SS',
    ESP: 'ES',
    LKA: 'LK',
    SDN: 'SD',
    SUR: 'SR',
    SJM: 'SJ',
    SWE: 'SE',
    CHE: 'CH',
    SYR: 'SY',
    TWN: 'TW',
    TJK: 'TJ',
    TZA: 'TZ',
    THA: 'TH',
    TLS: 'TL',
    TGO: 'TG',
    TKL: 'TK',
    TON: 'TO',
    TTO: 'TT',
    TUN: 'TN',
    TUR: 'TR',
    TKM: 'TM',
    TCA: 'TC',
    TUV: 'TV',
    UGA: 'UG',
    UKR: 'UA',
    ARE: 'AE',
    GBR: 'GB',
    UMI: 'UM',
    USA: 'US',
    URY: 'UY',
    UZB: 'UZ',
    VUT: 'VU',
    VEN: 'VE',
    VNM: 'VN',
    VGB: 'VG',
    VIR: 'VI',
    WLF: 'WF',
    ESH: 'EH',
    YEM: 'YE',
    ZMB: 'ZM',
    ZWE: 'ZW',
    ALA: 'AX'
  };
  return iso2toIso3[countryISO3Code] || 'UNKNOWN';
};
/**
 * @return {string}
 */


exports.getISO2FromISO3CountryCode = getISO2FromISO3CountryCode;

function parseData(docData, name) {
  var prop = docData && docData.data && docData.data[0] && docData.data[0].properties.find(function (value) {
    return value.name === name;
  });
  return prop && prop.value;
}
/**
 * @return {string}
 */


function parseDocumentProps(docData, name) {
  var prop = docData && docData.properties.find(function (value) {
    return value.name === name;
  });
  return prop && prop.value;
}

var convertBlobToBase64 = function convertBlobToBase64(blobUrl) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
      var blob, reader;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(blobUrl).then(function (r) {
                return r.blob();
              });

            case 2:
              blob = _context.sent;
              reader = new FileReader();
              reader.onerror = reject;

              reader.onload = function () {
                resolve(reader.result);
              };

              reader.readAsDataURL(blob);
              return _context.abrupt("return", reader.result);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x4, _x5) {
      return _ref.apply(this, arguments);
    };
  }());
};

exports.convertBlobToBase64 = convertBlobToBase64;

var removeStringB64 = function removeStringB64(string) {
  return string.split(',').slice(1).join(',');
};

exports.removeStringB64 = removeStringB64;

function parseSettings(docData, name) {
  var prop = docData && docData.cafeSettings && docData.cafeSettings.find(function (value) {
    return value.key === name;
  });
  return prop && JSON.parse(prop.value);
}
/**
 * @param {originalValues} originalValues 
 * @param {fieldsToInterchange} ObjectKeys === typeOne keys, ObjecValues === typeTwo keys
 * @param [conditionOne, conditionTwo] types 
 * @param 'string' typeToSwitch
 * @return newValues 
 */


function switchValueByType(_ref2) {
  var originalValues = _ref2.originalValues,
      fieldsToInterchange = _ref2.fieldsToInterchange,
      types = _ref2.types,
      typeToSwitch = _ref2.typeToSwitch;
  if (!originalValues || !fieldsToInterchange || !types || !typeToSwitch) return console.error('Arguments are not valid');
  var newValues = (0, _cloneDeep.default)(originalValues);
  var typeOne = Object.keys(fieldsToInterchange);
  var typeTwo = Object.values(fieldsToInterchange);
  var originalKeysArray = Object.keys(newValues);
  var originalValuesArray = Object.values(newValues);

  var findAndInterchange = function findAndInterchange(_ref3) {
    var typeA = _ref3.typeA,
        typeB = _ref3.typeB,
        key = _ref3.key,
        index = _ref3.index,
        objectToEdit = _ref3.objectToEdit,
        values = _ref3.values;
    var fieldIndex = typeA.findIndex(function (field) {
      return field === key;
    });
    objectToEdit[typeB[fieldIndex]] = values[index];
    delete objectToEdit[typeA[fieldIndex]];
  };

  originalKeysArray.forEach(function (key, index) {
    if (typeOne.includes(key) && typeToSwitch === types[1]) {
      findAndInterchange({
        typeA: typeOne,
        typeB: typeTwo,
        objectToEdit: newValues,
        values: originalValuesArray,
        key: key,
        index: index
      });
    } else if (typeTwo.includes(key) && typeToSwitch === types[0]) {
      findAndInterchange({
        typeA: typeTwo,
        typeB: typeOne,
        objectToEdit: newValues,
        values: originalValuesArray,
        key: key,
        index: index
      });
    } else {
      return newValues[key];
    }
  });
  return newValues;
}
/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */


function mergeDeep() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!sources.length) return target;

  var newTarget = _toConsumableArray(target);

  sources.forEach(function (category) {
    var foundCat = newTarget.find(function (o) {
      return o.titleId === category.titleId;
    });
    var foundCatIndex = newTarget.findIndex(function (o) {
      return o.titleId === category.titleId;
    });

    if (foundCat) {
      return newTarget.splice(foundCatIndex, 1, _objectSpread(_objectSpread({}, category), {}, {
        fields: (0, _union.default)(foundCat.fields, category.fields),
        labels: _objectSpread(_objectSpread({}, category.labels), foundCat.labels)
      }));
    } else {
      return newTarget.push(category);
    }
  });
  return newTarget;
}

function titleCase(s) {
  if (typeof s !== 'string') return s;
  return s.replace(/([^A-Z])([A-Z])/g, '$1 $2') // split cameCase
  .replace(/[_-]+/g, ' ') // split snake_case and lisp-case
  .toLowerCase().replace(/(^\w|\b\w)/g, function (m) {
    return m.toUpperCase();
  }) // title case words
  .replace(/\s+/g, ' ') // collapse repeated whitespace
  .replace(/^\s+|\s+$/, ''); // remove leading/trailing whitespace
}